export const environment = {
  name: 'production',
  production: false,
  backendUrl: 'https://api.tamis.app.br/api/',
  dashboardUrl: 'https://dashfrontend-996053244722.southamerica-east1.run.app/', // Prod Streamlit dashboard
  tamisBotUrl: 'https://chatbot-dashboard-396x.vercel.app/login', // Tamis Bot URL
  chatbotServiceUrl: 'https://chatbot-service-996053244722.southamerica-east1.run.app/',
  inferenceServiceUrl: 'https://inference-service-dev-996053244722.southamerica-east1.run.app',
  igestoAuthToken: 'igestoAuthToken',
  firebaseConfig: {
    apiKey: 'AIzaSyAt7DBe8Qlq0ISgeZNq4rF3SMoNzTv6wOc',
    authDomain: 'clarity-igesto.firebaseapp.com',
    projectId: 'clarity-igesto',
    storageBucket: 'clarity-igesto.appspot.com',
    messagingSenderId: '996053244722',
    appId: '1:996053244722:web:37f2c55abbc4f0e0e4952b',
  },
  accessTokenExpiration: 60,
  refreshTokenExpiration: 720,
  sessionExpiration: 720,
  templatesUrl: 'https://storage.googleapis.com/igesto-public-files/templates',
  importCreatePath: 'import-create',
  tenantId: 'production-48gfo',
  version: "1.1.16.302f069c",
};
